import * as React from 'react';

const BedrijvenZoekerOption = props => {
  const { data } = props;
  
  if (data && !!data["__isNew__"]) {
      return <article  className="option__bedrijfzoeker-bedrijf" onClick={props.onNewClick}>
          <div className='font-italic'><strong>Werkgever niet gevonden?</strong></div><div className='font-italic'>Klik hier om deze handmatig toe te voegen.</div>      
    </article>;
  }
  return (
    <article {...props} className="option__bedrijfzoeker-bedrijf">
      <div><strong>{data?.data?.Bedrijfsnaam ?? ""}</strong></div>
      <div>{data?.data?.CaoNaam}</div>
      <div>{data?.data?.Straat ?? ""} {data?.data?.AddressLine1 ?? ""}</div>
      <div>{data?.data?.PostalCode ?? ""} {data?.data?.Plaats ?? ""}</div>
    </article>
  );
};

const DefaultZoekerOption = props => {
  const { data } = props;
  
  if (data && !!data["__isNew__"]) {
      return <article className="option__defaultzoeker">
          <div><strong>Create?</strong></div>                
    </article>;
  }

  return (
    <article className="option__defaultzoeker">
      <div><strong>Default template</strong></div>      
    </article>
  );
};

export const getOptionTemplate = (formFieldDefinition : any) => {
  if (formFieldDefinition.PicklistTemplate == "bedrijvenzoeker") {
    return BedrijvenZoekerOption;
  }
  return DefaultZoekerOption;
};